import
  React, {
  useCallback,
  useEffect,
  useRef,
  useState
} from 'react';

import {
  useLocation
} from 'react-router-dom';

import {
  Text,
  VContainer
} from '@vodacom/web-common';

import
  styled
from 'styled-components';

import {
  DrupalProvider
} from '../providers';

import {
  CacheKeys
} from '../constants';

import {
  HandleRender,
  withScreenViewTagging
} from 'hocs';

const ContentStyled = styled(Text)`
  h1 {
    font-size: 26px;
  }
  h2 {
    font-size: 20px;
  }
  h3 {
    font-size: 18px;
  }
`;

const PageContainer = styled(VContainer)`
  overflow-x: hidden;
  overflow-wrap: break-word;
`;

const BasicUI = () => {

  const location = useLocation();

  BasicUI.pageName = `cbu: connectu: ${location.state?.item?.url}`;

  BasicUI.tagViewData = {
    page_section: location.state?.item?.url
  };

  const mountedRef = useRef(true);
  const [ page, setPage ] = useState(null);
  const [ state, setState ] = useState({
    loading: true,
    hasError: false,
    error: null
  });

  const getPage = useCallback(async() => {

    const response = await DrupalProvider.getCachedItem(CacheKeys.Pages, null, DrupalProvider.getPages);

    if (!mountedRef.current) {
      return;
    }

    if (!response?.ok) {

      setState(prevState => {
        return {
          ...prevState,
          loading: false,
          hasError: true,
          error: response.error
        };
      });

      return;
    }

    if (response?.result) {

      setState(prevState => {
        return {
          ...prevState,
          loading: false
        };
      });

      setPage(response.result.find(page => page.cmsPath === location.state?.item?.url));

      return;
    }

    setState(prevState => {
      return {
        ...prevState,
        loading: false,
        hasError: true,
        error: new Error('InvalidResponse')
      };
    });

  }, [ location.state?.item?.url ]);

  useEffect(() => {
    mountedRef.current = true;

    getPage();

    return () => {
      mountedRef.current = false;
    };
  }, [ getPage ]);

  return (

    <HandleRender
      isLoading={state.loading}
      isError={state.hasError}>
      {
        <PageContainer
          maxWidth={'100%'}
          padding={'16px'}>

          {
            page &&
            <>
              <Text
                padding={'16px 0'}
                fontSize={'26px'}
                fontWeight={'bold'}>
                {page.title}
              </Text>

              <ContentStyled
                dangerouslySetInnerHTML={{ __html: page.content }} />
            </>
          }

        </PageContainer>
      }
    </HandleRender>
  );
};

export const Basic = withScreenViewTagging(BasicUI);
